module.exports = __webpack_public_path__ + "static/media/materials_en.9b9b2e09.png";